import {Spinner, Message} from '../../index'
import {
    inputText,
} from '../../../utils/dynamicForm';
import {
    inputImagesBlock
} from "../../../utils/imageTools";

export const FormBrands = ({
                               edit,
                               formCleanHandler,
                               isLoading,
                               register,
                               isError,
                               isErrorUpdate,
                               errors,
                                setValue,
                                watch,
                                imageThumbnails,
                                images_path,
                                fileInputs,
                                setFileInputs,
                               isLoadingUpdate,
                               isLoadingPost,
                               handleSubmit,
                               submitHandler,
                               error,
                               // dataMachines,
                           }) => {


    // console.log('formBrands' );
    // console.log( dataMachines);

    return (
        <div
            className='modal fade'
            id='brandModal'
            data-bs-backdrop='static'
            data-bs-keyboard='false'
            tabIndex='-1'
            aria-labelledby='brandModalLabel'
            aria-hidden='true'
        >
            <div className='modal-dialog'>
                <div className='modal-content modal-background'>
                    <div className='modal-header'>
                        <h3 className='modal-title ' id='brandModalLabel'>
                            {edit ? 'Edit Brands' : 'Add a NEW Brand'}
                        </h3>
                        <button
                            type='button'
                            className='btn-close'
                            data-bs-dismiss='modal'
                            aria-label='Close'
                            onClick={formCleanHandler}
                        ></button>
                    </div>
                    <div className='modal-body'>
                        {isLoading ? (
                            <Spinner/>
                        ) : isError ? (
                            <Message variant='danger'>{error}</Message>
                        ) : isErrorUpdate ? (
                            <Message variant='danger'>{error}</Message>
                        ) : (
                            <form onSubmit={handleSubmit(submitHandler)}>
                                {inputText({
                                    register,
                                    errors,
                                    label: 'Brand ID',
                                    name: 'brand_id',
                                    placeholder: '',
                                    isRequired: true,
                                })}
                                {/*{inputText({*/}
                                {/*    register,*/}
                                {/*    errors,*/}
                                {/*    label: 'Brand Name',*/}
                                {/*    name: 'brand_name',*/}
                                {/*    placeholder: '',*/}
                                {/*    isRequired: true,*/}
                                {/*})}*/}


                                {inputText({
                                    register,
                                    errors,
                                    label: 'Brand Name',
                                    name: 'brand_name',
                                    placeholder: '',
                                    isRequired: true,
                                })}

                                {inputImagesBlock({
                                    setValue,
                                    errors,
                                    watch,
                                    register,
                                    label: 'Images',
                                    name: 'images',
                                    placeholder: '',
                                    isRequired: false,
                                    imageThumbnails,
                                    images_path,
                                    fileInputs,
                                    setFileInputs,
                                    maxImages: 1

                                    // initialValue: watch('items'),
                                })}
                                <div className='modal-footer'>
                                    <button
                                        type='button'
                                        className='btn btn-secondary '
                                        data-bs-dismiss='modal'
                                        onClick={formCleanHandler}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type='submit'
                                        className='btn btn-primary '
                                        disabled={isLoadingPost || isLoadingUpdate}
                                    >
                                        {isLoadingPost || isLoadingUpdate ? (
                                            <span className='spinner-border spinner-border-sm'/>
                                        ) : (
                                            "Save"
                                        )}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FormBrands
